/**
 * Payment initiation — Cashflows Hosted Payment Page (HPP).
 *
 * Flow:
 *   1. Server creates a payment intent → returns { redirect_url }.
 *   2. Browser navigates to that URL. Cashflows hosts the entire checkout
 *      UX (card, Apple Pay, 3DS) on their domain.
 *   3. Cashflows redirects back to /payment/success | /payment/failed |
 *      /payment/cancelled with the order_ref in the query string.
 *   4. Meanwhile Cashflows fires our webhook server-to-server; the webhook
 *      handler retrieves authoritative status and issues tickets. The browser
 *      is NEVER trusted to say "paid".
 */
import { startCheckout } from '@/lib/api';

export const initiatePayment = async ({
  competition,
  quantity,
  user,
  skillAnswerIndex,
  marketingOptIn = false,
}) => {
  if (!competition) throw new Error('Missing competition');
  if (!user) throw new Error('Missing signed-in user');
  if (skillAnswerIndex == null || skillAnswerIndex < 0) {
    // Any answer is acceptable — we only require that ONE was chosen. Right
    // vs wrong is deliberately never checked (DCMS Code: equal odds).
    throw new Error('Missing skill answer');
  }

  const res = await startCheckout({
    competition_id: competition.id,
    quantity,
    email: user.email,
    full_name: user.full_name,
    skill_answer_index: skillAnswerIndex,
    origin_url: window.location.origin,
    marketing_opt_in: !!marketingOptIn,
  });

  if (!res?.redirect_url) {
    throw new Error('Payment session could not be started');
  }
  // Full browser navigation — this leaves our site until Cashflows redirects back.
  window.location.href = res.redirect_url;
  return { order_ref: res.order_ref };
};

export default initiatePayment;
